import { useState } from 'react';

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState('');

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(''), 2200);
  };

  const handleShare = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch {
        return;
      }
    }
    showToast('当前浏览器暂不支持系统分享，请使用下方复制链接。');
  };

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      showToast('链接已复制（演示效果，未做后台统计）');
    } catch {
      showToast('复制失败，请手动复制地址栏链接。');
    }
  };

  return (
    <div className="relative flex items-center gap-2 flex-wrap">
      <span className="text-sm text-foreground-500 mr-1 flex items-center gap-1 whitespace-nowrap">
        <i className="ri-share-forward-line"></i>
        分享
      </span>
      <button
        type="button"
        onClick={handleShare}
        className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
        title="系统分享"
        aria-label="系统分享"
      >
        <i className="ri-share-line text-lg"></i>
      </button>
      <button
        type="button"
        onClick={handleCopy}
        className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
        title="复制链接"
        aria-label="复制链接"
      >
        <i className="ri-link text-lg"></i>
      </button>
      <button
        type="button"
        onClick={() => showToast('演示效果，社交分享接口待接入')}
        className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
        title="分享到微博"
        aria-label="分享到微博"
      >
        <i className="ri-weibo-line text-lg"></i>
      </button>

      {toast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm">
          {toast}
        </div>
      )}
    </div>
  );
}